<template>
  <div class="tree-panel">
    <div class="tree-panel-header">{{ title }}</div>
    <tree-search-select
      v-model="searchValue"
      :search-type="searchType"
      @change="applyTreeFilter"
    />
    <div class="tree-panel-body">
      <el-tree
        ref="tree"
        node-key="id"
        :data="treeData"
        :props="defaultProps"
        highlight-current
        :expand-on-click-node="false"
        :default-expand-all="true"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
      >
        <span slot-scope="{ node, data }" class="tree-node-custom">
          <svg class="icon svg-icon tree-node-icon" aria-hidden="true" v-show="!node.expanded">
            <use xlink:href="#icon-folder"></use>
          </svg>
          <svg class="icon svg-icon tree-node-icon" aria-hidden="true" v-show="node.expanded">
            <use xlink:href="#icon-opened_folder"></use>
          </svg>
          <span class="tree-node-label" :title="data.label">{{ data.label }}</span>
          <el-button
            v-if="data.parentId !== null"
            type="text"
            class="tree-node-delete"
            @click.stop="handleDeleteClick(data)"
          >
            <i class="el-icon-delete"></i>
          </el-button>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import TreeSearchSelect from './TreeSearchSelect.vue'

export default {
  name: 'FolderTreePanel',
  components: {
    TreeSearchSelect
  },
  props: {
    title: {
      type: String,
      default: '文件夹'
    },
    treeData: {
      type: Array,
      default: () => []
    },
    currentId: {
      type: String,
      default: ''
    },
    searchType: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      searchValue: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  watch: {
    currentId: {
      immediate: true,
      handler (val) {
        this.$nextTick(() => {
          if (this.$refs.tree && val) {
            this.$refs.tree.setCurrentKey(val)
          }
        })
      }
    }
  },
  methods: {
    applyTreeFilter (value) {
      if (this.$refs.tree) {
        this.$refs.tree.filter(value || '')
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) > -1
    },
    handleNodeClick (data) {
      this.$emit('node-click', data)
    },
    handleDeleteClick (data) {
      this.$emit('delete-node', data)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tree-panel
  height 100%
  background #fff
  border-radius 5px
  padding 10px
  box-sizing border-box
  display flex
  flex-direction column

.tree-panel-header
  font-size 14px
  font-weight 600
  color #303133
  margin-bottom 10px

.tree-filter
  margin-bottom 10px

.tree-panel-body
  flex 1
  overflow auto

>>> .el-tree-node__content
  width 100%
  box-sizing border-box

>>> .el-tree-node.is-current > .el-tree-node__content
  background rgba(11, 183, 142, .12)

.tree-node-custom
  width 100%
  display inline-flex
  align-items center
  overflow hidden
  padding-right 12px
  box-sizing border-box

.tree-node-icon
  flex 0 0 auto
  width 14px
  height 14px
  margin-right 6px

.tree-node-label
  flex 1
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.tree-node-delete
  flex none
  margin-left 8px
  color #F56C6C
  display none
  padding 0

>>> .el-tree-node__content:hover .tree-node-delete
  display inline-flex

.tree-node-delete .el-icon-delete
  font-size 14px
</style>
